import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import ValidatedField from 'components/controls/validated-field';
import ValidatedMultiSelectField from 'components/controls/validated-multi-select-field';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { translationApi  } from 'actions/translation-api';
import { changeSearchCriteria } from 'store/client/slice.client-list-filter';
import getClientStatusDescription, { CLIENT_STATUS_ACTIVE, CLIENT_STATUS_INACTIVE } from 'data/enums/client-status-enum';
import { tryParseInt } from 'utils/number-utils';

const ClientSearchFilter = () => {
    const dispatch = useDispatch();
    const [submitEnabled, setSubmitEnabled] = useState(true);
	const clientListFilter = useSelector(state => state.clientListFilter);
    const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

    const handleSubmit = fields => {
        const filter = {
            clientId: tryParseInt(fields?.clientId),
            name: fields?.clientName,
            vatin: fields?.clientVatin,
            statuses: fields?.statuses,
            page: 1,
        };
        dispatch(changeSearchCriteria(filter));

        setSubmitEnabled(false);
        setTimeout(() => setSubmitEnabled(true), 1000);
    };

    const statusesToSelect = [
        { value: CLIENT_STATUS_ACTIVE, label: getClientStatusDescription(CLIENT_STATUS_ACTIVE, translations) },
        { value: CLIENT_STATUS_INACTIVE, label: getClientStatusDescription(CLIENT_STATUS_INACTIVE, translations) },
    ];

    const validationSchema = Yup.object().shape({
        clientId: Yup.number()
            .typeError(translations.warningValueInvalid),
        clientName: Yup.string(),
        clientVatin: Yup.string()
            .max(10, translations.warningValueTooLong),
        statuses: Yup.array(),
    });

    const initialValues = {
        clientId: clientListFilter?.clientId?.toString().padStart(4, '0') ?? "",
        clientName: clientListFilter?.name ?? "",
        clientVatin: clientListFilter?.vatin ?? "",
        statuses: clientListFilter?.statuses ?? [ CLIENT_STATUS_ACTIVE ],
    };

    const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={fields => { handleSubmit(fields) }}>
            {props => (
                <Form autoComplete={randomAutoComplete}>
                    <div className="col-12 mb-4">
                        <div className="card border-light shadow-sm">
                            <div className="card-body">
                                <h2 className="h6 mb-2">{translations.filters}</h2>
                                <div className="row">
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <ValidatedField name="clientId" placeholder={translations.number} maxLength="4" {...props} />
                                    </div>
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <ValidatedField name="clientName" placeholder={translations.name} {...props} />
                                    </div>
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <ValidatedField name="clientVatin" placeholder={translations.vatin} maxLength="10" {...props} />
                                    </div>
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <ValidatedMultiSelectField name="statuses" placeholder={translations.status} options={statusesToSelect} isMulti={true}
                                            onChange={props.setFieldValue}
                                            onBlur={props.setFieldTouched} {...props} />
                                    </div>
                                    <div className="col-lg-2 col-md-12 mb-2">
                                    </div>
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <button id="searchButton" type="submit" className="btn btn-secondary float-end" disabled={submitEnabled ? null : 'disabled'} ><FontAwesomeIcon icon={faSearch} className="me-2" />{translations.actionSearch}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>)}
        </Formik>
    )
}

export default ClientSearchFilter;
